import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import statisticService from '../../../services/statistics';
import sellerStatisticService from '../../../services/seller/statistics';
import moment from 'moment';

const initialState = {
  loading: false,
  topCustomers: [],
  error: '',
  params: {
    time: 'subMonth',
    perPage: 5,
  },
};

// Helper function to build API params with proper priority
const buildApiParams = (params = {}) => {
  const apiParams = { ...params };
  
  // If date_from is provided, use date range and remove time
  if (apiParams.date_from) {
    apiParams.date_to = apiParams.date_to || moment().format('YYYY-MM-DD');
    delete apiParams.time;
  } else if (!apiParams.time) {
    // Default to subMonth if neither date_from nor time is provided
    apiParams.time = 'subMonth';
  }
  
  return apiParams;
};

export const fetchTopCustomers = createAsyncThunk(
  'statistics/fetchTopCustomers',
  (params = {}) => {
    const apiParams = buildApiParams({ ...initialState.params, ...params });
    return statisticService.topCustomers(apiParams).then((res) => res);
  }
);
export const fetchSellerTopCustomers = createAsyncThunk(
  'statistics/fetchSellerTopCustomers',
  (params = {}) => {
    const apiParams = buildApiParams({ ...initialState.params, ...params });
    return sellerStatisticService.topCustomers(apiParams).then((res) => res);
  }
);

const topCustomerSlice = createSlice({
  name: 'topCustomers',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchTopCustomers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTopCustomers.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.topCustomers = payload?.data?.data || [];
      state.error = '';
    });
    builder.addCase(fetchTopCustomers.rejected, (state, action) => {
      state.loading = false;
      state.topCustomers = [];
      state.error = action.error.message;
    });

    builder.addCase(fetchSellerTopCustomers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchSellerTopCustomers.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.topCustomers = payload?.data?.data || [];
      state.error = '';
    });
    builder.addCase(fetchSellerTopCustomers.rejected, (state, action) => {
      state.loading = false;
      state.topCustomers = [];
      state.error = action.error.message;
    });
  },
  reducers: {
    filterTopCustomers(state, action) {
      const { payload } = action;
      state.params = payload;
    },
  },
});
export const { filterTopCustomers } = topCustomerSlice.actions;
export default topCustomerSlice.reducer;
